
import ReportNotice from './ReportNotice'
import Rater from 'vux/src/components/rater/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import Spinner from 'vux/src/components/spinner/index.vue'
import Divider from 'vux/src/components/divider/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import PanelItem from '@components/common/panel-item'
import { getVioReportList, getuserInfo } from '@/service/vioReport'

import { IMG_SHOW_SERVER } from '@/consts/const'
import {getAppConfig} from '../../service/vioReport'
export default {
components: {
Rater,
ReportNotice,
Swiper,
Checker,
CheckerItem,
PanelItem,
Spinner,
Divider,
Tabbar,
TabbarItem
},
data () {
return {
star: 0,
num: 1,
currentType: 0,
vioReportList: [],
vioTypeList: [],
showImgServer: IMG_SHOW_SERVER,
swiperList: [],
statusDict: {
0: {
className: '',
text: '未受理'
},
5: {
className: 'no-pass',
text: '已受理'
},
15: {
className: 'passed',
text: '已办结反馈'
},
14: {
className: 'passed',
text: '已办结反馈'
},
12: {
className: 'waiting',
text: '正在调查'
},
10: {
className: 'waiting',
text: '正在调查'
}
},
showSupplement: false 
}
},
watch: {






},
created () {
getVioReportList({ params: {} })
.then((response) => {
const result = response.data
this.vioReportList = result.data || []
this.num = this.vioReportList.length
})
.catch((error) => {
this.vioReportList = []
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
this.initConfig()
},
mounted () {
if (sessionStorage.getItem('currentType')) {
this.currentType = Number(sessionStorage.getItem('currentType'))
} else {
this.currentType = 0
}
this.getUser()
console.log(this.currentType, '555this.currentType')
},
methods: {
initConfig () {
getAppConfig().then((response) => {
const result = response.data
this.showSupplement = result.data.showSupplement
})
},

getUser () {
getuserInfo()
.then((res) => {
console.log(res, 'user')
const result = res.data
if (result.data) {


}
})
.catch((error) => {
this.$vux.toast.show({
text: error,
type: 'warn'
})
})
},
goBc (item) {
this.$router.push({
name: 'reportSupplement',
path: '/reportSupplement',
query: { id: item.id }
})
},

isShowReward (rewardStatus) {
return rewardStatus !== null && rewardStatus !== undefined && rewardStatus !== ''
},

isWaitFill (rewardStatus) {
return String(rewardStatus) === '0'
},

rewardStatusClass (rewardStatus) {
const rs = String(rewardStatus)
if (rs === '0') return 'reward-wait-fill'
if (rs === '1') return 'reward-wait-grant'
if (rs === '2') return 'reward-granted'
return ''
},

goRewardBank (item) {
const str = JSON.stringify(item)
sessionStorage.setItem('reportItem', str)
this.$router.push({
name: 'rewardBank',
path: '/rewardBank',
query: { id: item.id }
})
},

throughDetail (item) {
const str = JSON.stringify(item)
sessionStorage.setItem('reportItem', str)
this.$router.push({ name: 'reportDetail', path: '/reportDetail' })
}
}
}



// WEBPACK FOOTER //
// ./src/views/vioReport/VioReportIndex.vue